import {nextTick} from 'vue';
import axios from 'axios';
import {globalActions} from '../../store/global-actions';

function initAutocompleteComponent(app) {
    app.component('autocomplete', {
        template: '#autocomplete',
        props: {
            modelValue: {
                type: String,
            },
            placeholder: {
                type: String,
            },
            autocompleteUrl: {
                type: String,
                required: true,
            },
            placeDetailsUrl: {
                type: String,
                required: true,
            },
            hasSearchButton: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['update:modelValue'],
        data() {
            return {
                address: this.modelValue,
                addresses: [],
                showAutocompleteResults: false,
                selectedAddressIndex: 0,
            };
        },
        watch: {
            modelValue(val) {
                this.address = val;
            },
        },
        methods: {
            checkClickTarget(event) {
                if (event.target !== this.$refs.input && event.target !== this.$refs.list) {
                    this.blurAutocomplete();
                }
            },
            input(event) {
                this.address = event.target.value;
                this.$emit('update:modelValue', this.address);
                this._setAddresses();
            },
            blurAutocomplete() {
                this._changeAutocompleteListIsOpened(false);
                this.selectedAddressIndex = 0;
            },
            focusInput() {
                this._setAddresses();
                this.$refs.input.focus();
            },
            selectAddress(index) {
                if (this.addresses[index]) {
                    const url = `${this.placeDetailsUrl}/${this.addresses[index].placeId}`;
                    axios.get(url)
                        .then((res) => globalActions.autocompleteCallback(res.data))
                        .catch(() => globalActions.autocompleteCallback(null));

                    this.blurAutocomplete();
                } else {
                    globalActions.autocompleteCallback(null);
                }
            },
            focusPrevAddress() {
                if (this.selectedAddressIndex > 0) {
                    --this.selectedAddressIndex;
                }
            },
            focusNextAddress() {
                if (this.selectedAddressIndex < this.addresses.length - 1) {
                    ++this.selectedAddressIndex;
                }
            },
            _setAddresses() {
                if (this.address === '') {
                    this.addresses = [];
                    this._changeAutocompleteListIsOpened(false);
                }
                if (this.address) {
                    this._getAutocompleteResults();
                }
            },
            _getAutocompleteResults() {
                const googleQueryDelay = 100;
                const currentAddress = this.address;
                setTimeout(() => {
                    if (currentAddress === this.address) {
                        const url = `${this.autocompleteUrl}?input=${this.address}`;
                        axios.get(url)
                            .then((res) => {
                                this.addresses = res.data;
                                this._changeAutocompleteListIsOpened(this.addresses.length > 0);
                            })
                            .catch(() => globalActions.autocompleteCallback(null));
                    }
                }, googleQueryDelay);
            },
            _changeAutocompleteListIsOpened(state) {
                this.showAutocompleteResults = state;
            },
        },
    });


    app.component('autocomplete-list', {
        template: '#autocomplete-list',
        props: {
            addresses: {
                type: Array,
                default() {
                    return [];
                },
            },
            isActive: {
                type: Boolean,
                default: false,
            },
            selectedAddressIndex: {
                type: Number,
                required: true,
            },
        },
        computed: {
            formattedAddresses() {
                nextTick(() => {
                    this.adjustHeight();
                });
                return this.addresses.map((address) => {
                    const formattedAddress = {
                        main: address.mainAddressPart,
                        secondary: ` ${address.secondaryAddressPart}`,
                    };
                    address.matchingSubstrings.forEach((matchedSubstring) => {
                        formattedAddress.main = this._formatMatchedPart(address.mainAddressPart,
                            matchedSubstring.offset, matchedSubstring.length);
                    });
                    return formattedAddress;
                });
            },
        },
        methods: {
            select(index) {
                this.$emit('select-address', index);
            },
            adjustHeight() {
                const autocompleteItems = this.$refs.addresses;
                if (autocompleteItems && autocompleteItems[0]) {
                    const rect = autocompleteItems[0].getBoundingClientRect();
                    this.$el.style.maxHeight = `${window.innerHeight - rect.top}px`;
                }
            },
            _formatMatchedPart(address, offset, length) {
                const matchedWrapperStart = '<span class="autocomplete__list-item-address_main-matched">';
                const matchedWrapperEnd = '</span>';

                return `${address.substring(0, offset)}${matchedWrapperStart}${address.substring(offset, offset + length)}\
${matchedWrapperEnd}${address.substring(offset + length)}`;
            },
        },
    });
}

export default initAutocompleteComponent;
